import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'tw:flex tw:items-center tw:justify-center tw:peer tw:h-4 tw:w-4 tw:shrink-0 tw:rounded-sm tw:border',
      'tw:border-primary tw:shadow tw:focus-visible:outline-hidden tw:focus-visible:ring-1 tw:focus-visible:ring-ring tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
      'tw:data-[state=checked]:bg-primary tw:data-[state=checked]:text-primary-foreground',
      'tw:data-[state=indeterminate]:bg-primary tw:data-[state=indeterminate]:text-primary-foreground',
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('tw:flex tw:items-center tw:justify-center tw:text-current')}
    >
      {props.checked === 'indeterminate' ? <Minus className='tw:h-4 tw:w-4 tw:size-full' /> : <Check className='tw:h-4 tw:w-4 tw:size-full' />}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
